import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { usePermissions } from '@/contexts/PermissionContext';

// Specific user IDs that have access to onboarding pipeline
const AUTHORIZED_USER_IDS = [
  'db7c0002-40ba-4a7d-9fc8-bab4316008ce',
  '5b6f5c58-fdb0-4bc2-b74f-3d847519e58d',
  'dea9f3ed-8e88-4c51-845a-68b583cbeb96',
  'ed9f5160-0f2a-4788-8a4b-68ebf4bab16e',
  'cad5ff05-b71d-47df-aa93-f141ca1a7e17',
  'b7b0e29f-a8bb-4060-b73c-c4d3bd9c284c',
  '5b9a1e69-f817-4307-92d1-c5182b6e9597',
  '684c3a62-1363-4458-afc4-7bf6f65c6394',
  '0cdc3af7-39af-44bc-a5b8-ae75efbee3f0',
  // Biz Dev Reps
  '46f693c6-14ac-4fad-b08c-6d186e04ed6a', // Carter (Residential)
  '357a4093-7d70-4e08-9dda-aef0a19f4d81',  // Brandon (Commercial)
  // Joules tenant users
  'ca7a4122-06a8-4ac3-a16e-cefeb0b58392'  // tech+10@solerro.com (Joules Admin)
];

export function useOnboardingAccess() {
  const { user } = useAuth();
  const { hasPermission, loading: permissionLoading } = usePermissions();
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setHasAccess(false);
      setLoading(false);
      return;
    }

    // Check if user has superadmin permissions
    const hasSuperAdminRole = hasPermission('system.override') || hasPermission('tenant.manage');
    
    // Check if user ID is in the authorized list
    const hasAuthorizedUserId = AUTHORIZED_USER_IDS.includes(user.id);

    setHasAccess(hasSuperAdminRole || hasAuthorizedUserId);
    setLoading(permissionLoading);
  }, [user, hasPermission, permissionLoading]);

  return { hasAccess, loading };
} 